import axios from 'axios'
import { appConfig } from 'src/config/app.config'
import { getBearerToken } from 'src/utils/auth.utils'
import { errorResponseInterceptor } from '../interceptors/responseInterceptor'

export const MaestroClient = axios.create({
    baseURL: appConfig.maestroBaseUrl,
    headers: {
        'X-Caller-Service': 'experts-explorer',
    },
})

MaestroClient.interceptors.request.use(config => {
    const token = getBearerToken()
    if (token) {
        config.headers.Authorization = token
    }
    return config
})

MaestroClient.interceptors.response.use(response => response, errorResponseInterceptor)
